export default __webpack_public_path__ + "static/media/Despoiler's Arm-straps of Whispered Deeds.22022f04.jpg";